<template>
  <dl class="list list--definition list--clean">
    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.NAME') }}</dt>
    <dd class="text-start" dir="rtl">
      {{ data.name }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.PACKAGE_NAME') }}</dt>
    <dd class="text-latin" dir="ltr">
      {{ data.packageName }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.BUDGET') }}</dt>
    <dd class="text-start" dir="ltr">
      {{ priceFormat(data.budget) }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.SPENT_BUDGET') }}</dt>
    <dd class="text-start" dir="rtl">
      {{ priceFormat(data.spentBudget) }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.START_DATE') }}</dt>
    <dd class="text-start" dir="ltr">
      {{ translateDate(data.startDate) }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.END_DATE') }}</dt>
    <dd class="text-start" dir="ltr">
      {{ translateDate(data.endDate) }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.STATUS') }}</dt>
    <dd class="text-start" dir="ltr">
      {{ $t(data.status) }}
    </dd>
    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.TRACKER_STATUS') }}</dt>
    <dd class="text-start" dir="rtl">
      {{ $t(trackerStatus) }}
    </dd>
  </dl>
</template>

<script>
import { dateFormat } from '@/utils/date';
import { format as priceFormat } from '@/utils/number';
import lang from '@/mixins/lang';

export default {
  name: 'CampaignInfoList',
  mixins: [lang],
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    trackerStatus() {
      return this.data.hasTracker
        ? 'ADVERTISEMENT.CAMPAIGNS.HAS_TRACKER'
        : 'ADVERTISEMENT.CAMPAIGNS.DOESNT_HAVE_TRACKER';
    },
  },
  methods: {
    priceFormat,
    translateDate(date) {
      if (!date) return '';

      let toFormat = 'DD/MM/YYYY';

      if (this.lang === 'fa') {
        toFormat = 'jYYYY/jMM/jDD';
      }

      try {
        return dateFormat()(toFormat)(date);
      } catch (error) {
        return date;
      }
    },
  },
};
</script>
